export default __webpack_public_path__ + "static/media/SinistreAvatar.c987606f.svg";